<template>
  <div id="campaignsList">
    <div class="d-flex justify-content-between">
      <h4>Campaigns</h4>
      <b-button variant="outline-secondary" size="sm" v-b-modal.createCampaign>
        <b-icon icon="plus"/>
      </b-button>
    </div>

    <div class="d-flex justify-content-center mt-3" v-if="campaignIsLoad">
      <b-spinner variant="primary" type="grow"/>
      <b-spinner variant="primary" type="grow"/>
      <b-spinner variant="primary" type="grow"/>
    </div>

    <b-list-group class="mt-3">
      <b-list-group-item
        v-for="(campaign,i) in campaigns"
        v-bind:key="i"
        button
        :active="activeCampaign==campaign.id"
        @click="selectCampaign(campaign.id)"
      >
        {{campaign.title}}
      </b-list-group-item>
    </b-list-group>

    <b-modal 
      id="createCampaign"
      title="Create campaig"
      :ok-title="'Create'"
      @ok="createCampaign"
    >
      <b-form-group
        id="title"
        label="Campaig title"
        label-for="title"
      >
        <b-form-input id="name" v-model="newCampaign.title"></b-form-input>
      </b-form-group>
      
      <b-form-group
        id="name"
        label="Campaig subtitle"
        label-for="subtitle"
      >
        <b-form-input id="subtitle" v-model="newCampaign.subtitle"></b-form-input>
      </b-form-group>

      <b-form-group id="iconWrap" label-cols="4" label-cols-lg="3" :label="$t('files.icon')" label-for="icon">
        <b-form-file
          id="icon"
          v-model="newCampaignIcon"
          :state="Boolean(newCampaignIcon)"
          :placeholder="$t('files.chooseFile')"
          :drop-placeholder="$t('files.dropFileHere')"
          accept="*"
          class="text-nowrap text-truncate"
        />
      </b-form-group>

      <b-form-group id="videoWrap" label-cols="4" label-cols-lg="3" :label="$t('files.video')" label-for="video">
        <b-form-file
          id="video"
          v-model="newCampaignVideo"
          :state="Boolean(newCampaignVideo)"
          :placeholder="$t('files.chooseFile')"
          :drop-placeholder="$t('files.dropFileHere')"
          accept="*"
          class="text-nowrap text-truncate"
        />
      </b-form-group>

      <b-form-group
        id="title"
        label="Video title"
        label-for="title"
      >
        <b-form-input id="title" v-model="newCampaign.video_title"></b-form-input>
      </b-form-group>

      <b-form-group
        id="description"
        label="Video description"
        label-for="description"
      >
        <b-form-input id="description" v-model="newCampaign.video_description"></b-form-input>
      </b-form-group>

      <b-form-group
        id="redirect"
        label="Redirect link"
        label-for="redirect"
      >
        <b-form-input id="redirect" v-model="newCampaign.redirect_link"></b-form-input>
      </b-form-group>

      <div class="d-flex justify-content-center mb-3" v-if="campaignCreateIsLoad">
        <b-spinner label="Loading..."></b-spinner>
      </div>
    </b-modal>

  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'campaignsList',
  props:{
    company:{
      type:Object,
      required:true,
    },
    activeCampaign:{
      default:null,
    }
  },
  data:function(){
    return {
      campaignCreateIsLoad:false,
      campaignIsLoad:false,
      newCampaign:{},
      newCampaignVideo:null,
      newCampaignIcon:null,
      campaigns:[],
    }
  },
  methods:{
    setEmptyCampingData(){
      this.newCampaign = {
        title:'',
        subtitle:'',
        video_title:'',
        video_description:'',
        redirect_link:'',
      };
      this.newCampaignVideo = null;
      this.newCampaignIcon = null;
    },
    createCampaign(bvModalEvt){

      bvModalEvt.preventDefault();//Prevent modal from closing

      if(this.campaignCreateIsLoad){
        return false;
      }
      this.campaignCreateIsLoad = true;

      let data = {
        date: new Date(),
        title: this.newCampaign.title,
        subtitle: this.newCampaign.subtitle,
        company: firebase.firestore().collection("companies").doc(this.company.id),
        redirect_link: this.newCampaign.redirect_link,
        icon_path: null,
      };

      let videoMeta = {
        customMetadata:{
          user: firebase.auth().currentUser.uid,
          originalFileName: this.newCampaignVideo.name,
          title: this.newCampaign.video_title,
          description: this.newCampaign.video_description,
        }
      };

      let videoData = {
        date: data.date,
        title: this.newCampaign.video_title,
        description: this.newCampaign.video_description,
        VidPush_link: null,
        download_url: null,
      };

      let storageRef = firebase.storage().ref();
      let time = new Date().getTime();

      let videoFilename = time + '.' + this.newCampaignVideo.name.split('.').pop();
      let iconFilename = time + '.' + this.newCampaignIcon.name.split('.').pop();

      storageRef.child('icons/' + this.company.id + '/' + iconFilename)
      .put(this.newCampaignIcon)
      .then(snapshot => {//uloaded icon
        //get downloadURL
        return snapshot.ref.getDownloadURL()
      })
      .then(downloadURL => {
        //upload video
        data.icon_path = downloadURL;
        return storageRef.child('videos/' + this.company.id + '/' + videoFilename)
          .put(this.newCampaignVideo)
      })
      .then(snapshot => {//uloaded
        //get downloadURL
        return snapshot.ref.getDownloadURL()
      })
      .then(downloadURL => {
        //add videos record
        videoData.video_url = downloadURL;
        return firebase.firestore()
        .collection('videos').add(videoData)
      })
      .then((videoRef) => {
        //add campaign
        data.video = videoRef;

        return firebase.firestore()
        .collection('campaigns').add(data)
      })
      .then((campaignRef)=>{
        //add campaigns to company
        data.id = campaignRef.id;
        videoMeta.customMetadata.campaign = campaignRef.id;

        let promises = [];

        promises.push(firebase.firestore()
          .collection("companies").doc(this.company.id)
          .update({
            campaigns: firebase.firestore.FieldValue.arrayUnion(campaignRef)
          }))
        promises.push(firebase.firestore()
          .collection("videos").doc(data.video.id)
          .update({
            campaign: campaignRef,
          }))
        promises.push(storageRef.child('videos/' + this.company.id + '/' + videoFilename)
          .updateMetadata(videoMeta))

        return Promise.all(promises)
      })
      .then(()=>{

        this.campaigns.push({
          id:data.id,
          title:data.title
        });

        this.selectCampaign(data.id);
        this.setEmptyCampingData();
        this.campaignCreateIsLoad = false;
        this.$bvModal.hide('createCampaign');
        
      })
      .catch((error)=>{
        this.campaignCreateIsLoad = false;
        console.error("Error adding document: ", error);
      });
    },
    selectCampaign(id){
      this.$emit('selectCampaign',id);
    }
  },
  watch:{
    company:{
      handler:function(newVal,oldVal) {
        if(oldVal && newVal.id == oldVal.id || !this.company.data().campaigns){
          return;
        }
        let promises = [];
        this.campaigns = [];
        this.campaignIsLoad = true;

        this.company.data().campaigns.forEach((doc)=>{
          promises.push(doc.get());
        })

        Promise.all(promises).then(results => {
          results.forEach((campaign) => {
            this.campaigns.push({
              id:campaign.id,
              title:campaign.data().title
            })
          });
          this.campaignIsLoad = false;
        })
      },
      immediate: true,
    },
  },
  mounted(){
    this.setEmptyCampingData()
  }
}
</script>